/**
 * Sort keys for TanstackTable column meta (design eval F36): `sortValue`
 * should order a column by what it means, not by how its cell is printed.
 */

/** A timestamp as epoch ms; missing or unparseable sorts first (0). */
export function timeValue(value: string | number | Date | null | undefined): number {
  if (value === null || value === undefined || value === '') return 0;
  const t = new Date(value).getTime();
  return Number.isNaN(t) ? 0 : t;
}

const HEALTH_RANK: Record<string, number> = { healthy: 0, degraded: 1, unhealthy: 2, offline: 3 };

/** Health as a rank: healthy, degraded, unhealthy, offline, then unknown. */
export function healthRank(status: string | null | undefined): number {
  return HEALTH_RANK[(status || '').toLowerCase()] ?? 4;
}
